module.exports = __webpack_public_path__ + "img/msocks.b3b54a6a.jpg";